import React, { useState } from "react";
import UserDashHead from "../../component/AuthHead/UserDashHead";
import UserDashTab from "../../component/AuthHead/UserDashTab";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const UserDash = () => {
  const profile = (
    <div className="col-lg-8">
      <h3>Profile</h3>
      <Container>
        <Form>
          <Row>
            <Col xs={12} md={6}>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>First Name</Form.Label>
                <Form.Control type="text" value={"Value"} disabled />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>Last Name</Form.Label>
                <Form.Control type="text" value={"Value"} disabled />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>Email</Form.Label>
            <Form.Control type="email" value={"Value"} disabled />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>Password</Form.Label>
            <Form.Control type="password" />
          </Form.Group>
          <Button className="battoun">Update Password</Button>
        </Form>
      </Container>
    </div>
  );
  const membership = (
    <div className="col-lg-8">
      <h3>Membership Form</h3>
      <Container>
        <Form>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>Membership Type</Form.Label>
            <Form.Select aria-label="Default select example" disabled>
              <option>Value</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>Sub group that best describes you</Form.Label>
            <Form.Select aria-label="Default select example" disabled>
              <option>Value</option>
            </Form.Select>
          </Form.Group>
          <Row>
            <Col xs={12} md={6}>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>First Name</Form.Label>
                <Form.Control type="text" value="Value" disabled />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>Last Name</Form.Label>
                <Form.Control type="text" value="Value" disabled />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6}>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>Gender</Form.Label>
                <Form.Control type="text" value="Value" disabled />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>Date of Birth</Form.Label>
                <Form.Control type="date" value={"2024-01-01"} disabled />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6}>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>Country of Location</Form.Label>
                <Form.Control type="text" value="Value" disabled />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>City of Location</Form.Label>
                <Form.Control type="text" value="Value" disabled />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>Email</Form.Label>
            <Form.Control type="email" value="Value" disabled />
          </Form.Group>

          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>
              Do you have authority to represent your organization{" "}
            </Form.Label>
            <Form.Select aria-label="Default select example" disabled>
              <option>Value</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>Job Title or Position</Form.Label>
            <Form.Control type="text" value="Value" disabled />
          </Form.Group>
        </Form>
      </Container>
    </div>
  );
  const collaboration = (
    <div className="col-lg-8">
      <h3>Collaboration Form</h3>
      <Container>
        <Form>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>Email</Form.Label>
            <Form.Control type="email" value={"Value"} disabled />
          </Form.Group>
          <Row>
            <Col xs={12} md={6}>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>First Name</Form.Label>
                <Form.Control type="text" value={"Value"} disabled />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>Last Name</Form.Label>
                <Form.Control type="text" value={"Value"} disabled />
              </Form.Group>
            </Col>
          </Row>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>Organization</Form.Label>
            <Form.Control type="text" value={"Value"} disabled />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>What is the status of your collaboration?</Form.Label>
            <Form.Select aria-label="Default select example">
              <option>Select Item</option>
              <option value="individual">
                Set Up: I have an idea, but looking for others to join
              </option>

              <option value="organization">
                Ideation: The group is brainstorming together
              </option>
              <option value="organization">
                Scoping: Problems, solutions and resources required are being
                defined
              </option>
              <option value="organization">
                Implementation: Expectations, deliverables and project deadlines
                are determined
              </option>
              <option value="organization">
                Growth/Scale: A scaling strategy is developed
              </option>
              <option value="organization">
                Influence: Advocacy efforts are undertaken with national and
                international stakeholders
              </option>
              <option value="organization">Other</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>Other</Form.Label>
            <Form.Control type="text" value={"Value"} disabled />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>
              Please briefly describe the objective of your collaboration. (ie.
              what is the system you would like to change or the problem you
              would like to solve and why) (150 words max)
            </Form.Label>
            <Form.Control as="textarea" rows={3} value={"Value"} disabled />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>
              Are there any organisations/individuals within the community that
              you are specifically interested in collaborating with?
            </Form.Label>
            <Form.Control as="textarea" rows={3} value={"Value"} disabled />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>Which region will your collaboration serve?</Form.Label>
            <Form.Control as="textarea" rows={3} value={"Value"} disabled />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>
              Please tell us which SDG(s) the collaboration will be addressing.
              (Please list your top 3.)
            </Form.Label>
            <Form.Check
              type={"checkbox"}
              id={"default"}
              label={"SDG 1: No poverty"}
            />
            <Form.Check
              type={"checkbox"}
              id={"default"}
              label={"SDG 2: Zero Hunger"}
            />
            <Form.Check
              type={"checkbox"}
              id={"default"}
              label={"SDG 3: Good Health and Well-being"}
            />
            <Form.Check
              type={"checkbox"}
              id={"default"}
              label={"SDG 4: Quality Education"}
            />{" "}
            <Form.Check
              type={"checkbox"}
              id={"default"}
              label={"SDG 5: Gender Equality"}
            />{" "}
            <Form.Check
              type={"checkbox"}
              id={"default"}
              label={"SDG 6: Clean Water and Sanitation"}
            />{" "}
            <Form.Check
              type={"checkbox"}
              id={"default"}
              label={"SDG 7: Affordable and Clean Energy"}
            />{" "}
            <Form.Check
              type={"checkbox"}
              id={"default"}
              label={"SDG 8: Decent Work and Economic Growth"}
            />{" "}
            <Form.Check
              type={"checkbox"}
              id={"default"}
              label={"SDG 9: Industry, Innovation and Infrastructure"}
            />{" "}
            <Form.Check
              type={"checkbox"}
              id={"default"}
              label={"SDG 10: Reduced Inequalities"}
            />{" "}
            <Form.Check
              type={"checkbox"}
              id={"default"}
              label={"SDG 11: Sustainable Cities and Communities"}
            />{" "}
            <Form.Check
              type={"checkbox"}
              id={"default"}
              label={"SDG 12: Responsible Consumption and Production"}
            />{" "}
            <Form.Check
              type={"checkbox"}
              id={"default"}
              label={"SDG 13: Climate Action"}
            />{" "}
            <Form.Check
              type={"checkbox"}
              id={"default"}
              label={"SDG 14: Life Below Water"}
            />{" "}
            <Form.Check
              type={"checkbox"}
              id={"default"}
              label={"SDG 15: Life on Land"}
            />
            <Form.Check
              type={"checkbox"}
              id={"default"}
              label={"SDG 16: Peace, Justice and Strong Institutions"}
            />
            <Form.Check
              type={"checkbox"}
              id={"default"}
              label={"SDG 17: Partnerships for the Goals"}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>
              {" "}
              Please tell us the main issue(s) this collaboration is
              addressing.?
            </Form.Label>
            <Form.Control type="text" value={"Value"} disabled />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label> Please indicate your collaboration needs.?</Form.Label>
            <Form.Control type="text" value={"Value"} disabled />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Form.Label>
              {" "}
              What do you need to get your collaboration started?
            </Form.Label>
            <Form.Control type="text" value={"Value"} disabled />
          </Form.Group>
        </Form>
      </Container>
    </div>
  );
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    { title: "Profile", content: profile },
    { title: "Membership Form", content: membership },
    { title: "Collaboration", content: collaboration },
  ];
  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  return (
    <div>
      <UserDashHead />

      <section id="service-details" className="service-details">
        <div className="container" data-aos="fade-up" data-aos-delay="100">
          <div className="row gy-4 mobcol">
            <UserDashTab
              activeTab={activeTab}
              tabs={tabs}
              handleTabClick={handleTabClick}
            />
            {tabs[activeTab]?.content}
          </div>
        </div>
      </section>
    </div>
  );
};

export default UserDash;
